<template>
  <WebshopOrderModal :webshop_product="webshop_product" ref="webshopmodal" />
</template>
<script>
import WebshopOrderModal from "@/layouts/layout-default/nonportal/components/webshop/WebshopOrderModal.vue";

export default {
  components: { WebshopOrderModal },
  data: () => ({
    overlay: false,
    webshop_product: {}
  }),
  mounted() {
    this.uuid = this.$route.params.product_uuid;
    this.$store
      .dispatch("webshop/getProduct", this.uuid)
      .then(response => {
        this.webshop_product = response.data;
        this.$refs.webshopmodal.showModal(); // use exposed method to show modal
      })
      .catch(() => {
        this.webshop_product = null;
        this.$refs.webshopmodal.showModal();
      });
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 2000);
    }
  }
};
</script>
